import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageloadService {

  constructor(private http: HttpClient) { }

  loadImage(ruta:string): Observable<Blob> {
    return this.http.get(ruta, { responseType: 'blob'});
  }
}
